export default "__VITE_ASSET__CXKvkDZr__"